import React from "react";

export const About = (props) => {
  return (
    <div id="about">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-md-12">
              <div className="about-text">
                <h2>About Us</h2>
                <p>Dotted Line is revolutionizing procurement consultancy, taking it to the next level with our innovative platform. We aim to be your ultimate solution for comprehensive procurement consultancy and management. Our mission is to empower seamless procurement processes, enhance collaboration, and drive efficiency through AI-driven solutions.</p>

                <div id="why-dl-container">
                    <h3>Why choose Dotted Line?</h3>
                    <div className="about-bullet">
                        <h5>Save Time and Drive Efficiency</h5>
                        <p>Dotted Line's AI-driven solutions will minimise manual efforts and drive efficiency.</p>
                    </div>
                    <div className="about-bullet">
                        <h5>Enhance Decision-Making</h5>
                        <p>Dotted Line's AI-driven insights will enable informed decision-making and optimise procurement strategies.</p>
                    </div>
                    <div className="about-bullet">
                        <h5>Focus on Strategic Growth</h5>
                        <p>Dotted Line will handle routine tasks, freeing you to focus on strategic growth and business development.</p>
                    </div>
                </div>
                
                <div id="ecovate-container">
                  <h3>Partnership with EcoVate Group</h3>
                  <p>Dotted Line has proudly partnered with EcoVate Group, a leader in procurement consultancy, management and commercial expertise. Through our collaboration we aim to enhance procurement processes, delivering exceptional results and value to our clients.</p>
                  <div className="about-bullet">
                    <h5>AI-Driven Procurement Consultancy</h5>
                    <p>EcoVate leverages Dotted Line's AI-driven capabilities to deliver exceptional procurement support. By integrating Dotted Line into its workflow, EcoVate ensures seamless consultancy from start to finish, with streamlined communication, real-time progress tracking, and improved decision-making processes. Dotted Line's AI innovations revolutionise EcoVate's operations, enabling greater efficiency, pattern recognition, and data-driven insights in procurement consultancy and management.</p>
                  </div>
                  <div className="about-bullet">
                    <h5>Elevated User Experience with AI-Driven Expertise</h5>
                    <p>Dotted Line users leverage EcoVate's AI-driven expertise to enhance their procurement consultancy experience. With EcoVate's support, users gain access to specialised guidance on procurement strategies, regulatory compliance, and strategic decision-making. EcoVate's consultancy expertise complements Dotted Line's AI-driven functionality, enriching the overall user experience and ensuring procurement success.</p>
                  </div>
                  <div id="ecovate-logo-container">
                    <a
                      href="https://ecovategroup.com/"
                      target="_blank"
                      className="btn btn-custom btn-lg ecovate-btn"
                    >
                      Explore EcoVate Group
                    </a>
                    <a
                      href="https://ecovategroup.com/"
                      target="_blank"
                    >
                      <img src="../img/logo_ecovate.png" alt="EcoVate Group Logo" style={{ width: '150px'}}/>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
